import { Rocket } from "lucide-react";
import ChallengeCardComp from "../ChallengeCardComp/ChallengeCardComp";
import { useNavigate } from "react-router-dom";
import UseInnerWidth from "hooks/UseInnerWidth";
import freeChallengeIcon from "../../../../Assets/Images/FreeChallengeIcon.svg";
import paidChallengeIcon from "../../../../Assets/Images/paidChallengeIcon.svg";
import freeChallengeIconLight from "../../../../Assets/Images/freeTrial.svg";
import paidChallengeIconLight from "../../../../Assets/Images/paid.svg";
import { useTheme } from "hooks/ThemeContext";

function ChallengeCard() {
  const { theme } = useTheme();
  const navigate = useNavigate();
  const width = UseInnerWidth();
  return (
    <div>
      <div
        className={`flex ${
          (width < 768 || (width > 1024 && width < 1250)) && "flex-col"
        }  gap-4`}
      >
        <ChallengeCardComp
          type={"FREE"}
          icon={
            <img
              src={
                theme === "light" ? freeChallengeIconLight : freeChallengeIcon
              }
              className="w-12"
            />
          }
          title={"Free Trial"}
          subtitle={"Realize your potential with zero risk"}
          rules={[
            "Not Eligible For Funding",
            "Basic Account Analysis",
            "Refine Your Trading Skills",
            "14 Days Access",
          ]}
          btnText={"Start Free Challenge"}
          onClick={() => {
            navigate("/createChallenge");
          }}
        />
        <ChallengeCardComp
          type={"PAID"}
          icon={
            <img
              src={
                theme === "light" ? paidChallengeIconLight : paidChallengeIcon
              }
              className="w-12"
            />
          }
          title={"Only Funds Evaluation"}
          subtitle={
            "Realize your potential and trade up to $100,000 of our capital"
          }
          rules={[
            "Up to $100,000 in Funding",
            "Multiple Account Options",
            "Full Account Analysis",
            "Daily Payouts",
          ]}
          btnText={"Start A New Challenge"}
          onClick={() => {
            navigate("/createPaidChallenge");
          }}
        />
      </div>
    </div>
  );
}

export default ChallengeCard;
